<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Verwijder opdracht</v-card-title>
        <v-card-text>
          <p>Weet je zeker dat je deze opdracht wilt verwijderen?</p>
          <p>Het gaat om:</p>
          <ul v-if="dialog">
            <li>Opdrachtgever: {{ itemToDelete.client }}</li>
            <li>Opdrachtkenmerk: {{ itemToDelete.assignment }}</li>
          </ul>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat @click="dialog = false; remove()">Ja</v-btn>
          <v-btn color="green darken-1" flat @click="dialog = false">Nee</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-data-table
        :headers="headersWithAssignment"
        :items="assignmentsFiltered"
        item-key="uniqueID"
        v-if="isAssignmentActive"
        :rows-per-page-items="[20,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
    >
      <template v-slot:items="props">
        <td class="text-xs-left">{{ props.item.created }}</td>
        <td class="text-xs-left">{{ props.item.client }}</td>
        <td class="text-xs-left">{{ props.item.assignment }}</td>
        <td class="text-xs-left">
          <v-btn icon flat color="primary">
            <v-icon class="pa-2" @click="loadAddresses(props.item.uniqueID)">list</v-icon>
          </v-btn>
          <v-btn icon flat color="primary" >
            <v-icon class="pa-2" @click="loadAssignmentForEdit(props.item.uniqueID)">edit</v-icon>
          </v-btn>
          <v-btn icon flat color="primary">
            <v-icon class="pa-2" @click="enableRemoveDialog(props.item)">delete_forever</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>
    <v-btn @click="gotoAassignmentAreaView" v-if="isAssignmentActive">Ga terug</v-btn>

    <address-list :addresses="addresses" v-if="isAddressActive"></address-list>

    <v-data-table
        :headers="headersWithArea"
        :items="assignmentsFilteredOnArea"
        item-key="uniqueID"
        v-if="isAssignmentAreaActive"
        :rows-per-page-items="[20,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
    >
      <template v-slot:items="props">
        <td class="text-xs-left">{{ props.item.created }}</td>
        <td class="text-xs-left">{{ props.item.client }}</td>
        <td class="text-xs-left">{{ props.item.area }}</td>
        <td class="text-xs-left">
          <v-btn icon flat color="primary">
            <v-icon class="pa-2" @click="loadAddressesByClientAndArea(props.item.keyArea)">list</v-icon>
          </v-btn>
          <v-btn icon flat color="primary">
            <v-icon class="pa-2" @click="loadAssignmentsByKeyArea(props.item.keyArea)">folder</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import {adminService as service, cookieService} from "@/services/admin";
import AddressList from "@/components/AddressList";

const flowItems = {
  ADDRESS_VIEW: "ADDRESS_VIEW",
  ASSIGNMENT_VIEW: "ASSIGNMENT_VIEW",
  ASSIGNMENT_AREA_VIEW: "ASSIGNMENT_AREA_VIEW"
}

export default {
  components: {
    AddressList
  },
  computed: {
    isAddressActive: function () {
      return this.flowState === flowItems.ADDRESS_VIEW;
    },
    isAssignmentActive: function () {
      return this.flowState === flowItems.ASSIGNMENT_VIEW;
    },
    isAssignmentAreaActive: function () {
      return this.flowState === flowItems.ASSIGNMENT_AREA_VIEW
    }
  },
  data: () => ({
    pagination: {
      sortBy: "name"
    },
    test: "",
    dialog: false,
    sending: false,
    selected: [],
    itemToDelete: null,
    headersWithAssignment: [
      {
        text: "Datum",
        align: "left",
        value: "created"
      },
      {text: "Opdrachtgever", value: "client"},
      {text: "Opdracht kenmerk", value: "assignemnt"},
      {text: "", value: ""} // give an empty to draw a line
    ],
    headersWithArea: [
      {
        text: "Datum",
        align: "left",
        value: "created"
      },
      {text: "Opdrachtgever", value: "client"},
      {text: "Wijk", value: "area"},
      {text: "", value: ""} // give an empty to draw a line
    ],
    assignments: [], // store and state, should not be used in view
    assignmentsFilteredOnArea: [],
    assignmentsFiltered: [],
    addresses: [],
    flowState: flowItems.ASSIGNMENT_AREA_VIEW
  }),
  methods: {
    gotoAassignmentAreaView() {
      this.flowState = flowItems.ASSIGNMENT_AREA_VIEW;
    },
    loadAssignments() {
      this.sending = true;
      // Retrieve raw assignments
      service.getAssignments().then(result => {
        this.sending = false;
        this.assignments = result.data.content.map(e => {
          e.keyArea = e.area + "-" + e.client;
          return e;
        });

        // filter raw assignments by area & client
        let alreadyFound = [];
        this.assignmentsFilteredOnArea = [];
        this.assignments.forEach(e => {
          if (!alreadyFound.includes(e.keyArea)) {
            this.assignmentsFilteredOnArea.push(e);
          }
          alreadyFound.push(e.keyArea);
        })
      });
    },
    loadAssignmentsByKeyArea(key) {
      this.assignmentsFiltered = this.assignments.filter(e => e.keyArea === key);
      this.flowState = flowItems.ASSIGNMENT_VIEW;
    },
    loadAddressesByClientAndArea(key) {
      this.sending = true;
      let assignmentIds = this.assignments.filter(e => e.keyArea === key).map(e => e.uniqueID);
      service.loadAddresses(assignmentIds).then(result => {
        this.sending = false;
        this.addresses = result.data;
        this.flowState = flowItems.ADDRESS_VIEW;
      });
    },
    loadAssignmentForEdit(assignmentId) {
      cookieService.save(cookieService.ACTIVE_ASSIGNMENT_ID, assignmentId);
      this.$router.push("/admin/assignment");
    },
    loadAddresses(assignmentId) {
      this.sending = true;
      service.loadAddresses(assignmentId).then(result => {
        this.sending = false;
        this.addresses = result.data;
        this.flowState = flowItems.ADDRESS_VIEW;
      });
    },
    enableRemoveDialog(item) {
      this.itemToDelete = item;
      this.dialog = true;
    },
    remove() {
      this.dialog = false;
      service
          .removeAssignment(this.itemToDelete.uniqueID)
          .then(() => {
            this.loadAssignments();
            this.assignmentsFiltered = this.assignmentsFiltered.filter(e => e.uniqueID !== this.itemToDelete.uniqueID);
          });
    }
  },
  watch: {
    addresses(newAddresses) {
      if (newAddresses.length === 0) {
        this.flowState = flowItems.ASSIGNMENT_AREA_VIEW;
      }
    }
  },
  created() {
    this.loadAssignments();
  }
};
</script>